import type { FaireProductEntity } from "../../entity_types/product";

export const p_75up5hgf2h: FaireProductEntity = {
  token: "p_75up5hgf2h",
  type: "product",
  name: "1967 Ford Mustang Shelby GT500 - Tin",
  brandToken: "b_4ztdnlvzm9",
  brandName: "Eurographics Puzzles USA",
  imageUrl:
    "https://cdn.faire.com/fastly/b1d945cbf3c7590e5c2bfdf3826e991702a0e657aef677dafed07c83f6c85e9e.webp",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e58cae65ab6617bf9545e7a44546e3ed1ad09f3392212a8a8ca2f03647f7c1bb.webp",
    "https://cdn.faire.com/fastly/8ef024f750d39979e2e8d1e389cbef22b061767d3249753dd2cb78ec789f6f89.webp",
    "https://cdn.faire.com/fastly/1c60e8f332f6df53a12f91f535569ae5f1d704a9da2cc91c80ae1df065987790.webp",
    "https://cdn.faire.com/fastly/f24847f8956122eea26c7a607e1ead39f6e2b689d897c7fa867c5bec8aa31605.webp",
  ],
  priceDollars: 16.63,
  description:
    "Eurographics 1967 Ford Mustang Shelby GT500 550 piece  Puzzle.\n\nStart your engines! This collectible tin—shaped like the legendary ’67 Shelby GT500—holds a premium 550-piece puzzle featuring a heart-warming driveway scene with the iconic fastback. Crisp printing and sturdy pieces make every detail of the classic stripes and chrome pop, while the display-worthy tin doubles as décor or storage for car lovers. An officially licensed Ford product, perfect for gearheads, puzzle fans, and anyone who dreams in V8.\n\nFord - OFFICIALLY LICENSED PRODUCT\n\n✨ Highlights\nPuzzle stored inside embossed tin packaging.\nPoster Included\nPrecision-Cut Pieces: Ensuring a snug fit and hours of relaxing enjoyment\nPremium Quality: Crafted with premium blueboard and a linen finish for a durable, glare-free experience.\nEco-Friendly: Manufactured using recycled and responsibly sourced materials.\nBox-Tin size: approx. 10.25 x 3 x 4 in (26 x 7.62 x 10.16 cm)\nAges: 12+\n\nOrientation:\tHorizontal\nAssembled puzzle size: \t19 x 13 in (33 x 48 cm)",
  tags: [],
  msrpDollars: 33.26,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:55:29.201Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
